import type {PopupLayout} from 'Shared/model/Components';
import { noteStyle } from 'Shared/forms/Wrap';
import { verticalStyle } from 'Shared/backend/Theme';
import { optionList } from 'Shared/backend/widgets/ComponentOptions';
import { IntegratedSelectorAndComponent } from 'Shared/backend/widgets/IntegratedSelectorAndComponent';
import { useLayout } from 'Shared/backend/LayoutProvider';
import { Show } from 'solid-js';


// TODO: possibly allow popups to be attached to buttons.<br/>
// TODO: a popup on page load checkbox. Maybe a first-time only option.<br/>

export function Popup(P:PopupLayout)
{
	const lo = useLayout();

	const options = optionList([],['popup']);

	return (
		<div class={verticalStyle()}>
			<Show when={lo.layout()}>
				<div class={noteStyle()}>
					Displays a popup when a page is loaded.
				</div>
			</Show>

			<IntegratedSelectorAndComponent {...P.content} label='Component' contentFieldName='content' options={options} required />
		</div>
	);
}

